<template>
  <v-container class="inner-main pt-2 mb-10 mt-10" fluid>
    <v-row justify="start" class="position-relative">
      <CustomSocialsShare :share="selectedPost?.shareUrl" :direction="'row'"
        style="position: absolute;top:-32px;right:0; }"></CustomSocialsShare>
      <v-row justify="center">
        <v-col cols="12" md="8" class="pr-md-0">
          <v-responsive style="max-height: 100%; overflow: hidden;" class="h-100 bg-black" max-height="100%"
            :aspect-ratio="1 / 1" content-class="d-flex align-items-center h-100">
            <v-carousel v-model="activeSlide" cycle :show-arrows="selectedPost?.images.length >= 2" contain class="h-100" >
              <v-carousel-item :aspect-ratio="1 / 1" class="" v-for="post in selectedPost?.images" :key="post.id"
                :src="`${$cloudFrontApi}${post.id}/STREAM_RETINA`" contain></v-carousel-item>
            </v-carousel>
          </v-responsive>
        </v-col>
        <v-col cols="12" md="4" class="pl-md-0">
          <v-card class="w-100 h-100 d-flex flex-column post-popup" rounded="0" color="#f5f5f5">
            <v-card-item style="background-color: #ededed;">
              <v-list-item class="w-100 text-left px-0" color="#ededed">
                <template v-slot:prepend>
                  <v-avatar color="grey-darken-3" rounded="0" size="50"
                    :image="`${$cloudFrontApi}${ selectedPost?.shop ? selectedPost?.shop.avatar : selectedPost?.user.avatar }/AVATAR`"></v-avatar>
                </template>

                <v-list-item-title class="mb-2 clickable" @click="selectedPost?.shop ? null : openDownloadAppHint()">{{ selectedPost?.shop ? selectedPost?.shop.name : selectedPost?.user.username }}</v-list-item-title>

                <v-list-item-subtitle>{{ selectedPost?.shop ? selectedPost?.shop.tagline : selectedPost?.user.profile['fields']?.bio?.value }}</v-list-item-subtitle>
              </v-list-item>
            </v-card-item>
            <v-card-text>
              <div class="news-post-info d-flex justify-content-between my-2">
                <span>{{ $t(selectedPost?.category.name ?? selectedPost?.category ?? "") }}</span>

                <span class="post-start">{{ $getTimeDuration(selectedPost?.lastModified) }}</span>
              </div>
              <h6>{{ selectedPost?.headline }}</h6>
              <p class="news-post-text">
                {{ selectedPost?.text }}
              </p>
              <v-divider></v-divider>
              <p class="fst-italic" v-if="selectedPost?.productGroups.length > 1">{{ $t('main.streamwall.full-stream.products') }} {{selectedPost?.productGroups.map(product => product.translations[selectedLanguage.toUpperCase()].value).join(', ')
              }}</p>
              <p class="fst-italic" v-if="selectedPost?.brands.length > 1">{{ $t('main.streamwall.full-stream.brands') }} {{selectedPost?.brands.map(brand => brand.name).join(', ')}}</p>
              <v-row>
                <CustomProductLabel v-for="label in selectedPost?.labels" :key="label.id" :label="label" />
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-auto d-flex flex-column justify-text-left align-start">
              <v-btn v-if="selectedPost?.shop != null" variant="flat" size="large" color="primary" rounded="lg" prepend-icon="mdi-cart-outline"
                class="white--text mb-2" @click="reserve">{{ $t('main.streamwall.full-stream.product-link') }}</v-btn>
              <v-btn v-if="selectedPost?.shop != null" variant="flat" size="large" color="primary" rounded="lg" prepend-icon="mdi-mail"
                class="white--text mb-2" @click="reserve">{{ $t('main.streamwall.full-stream.contact_store') }}</v-btn>
              <v-btn v-if="selectedPost?.shop != null" variant="flat" size="large" color="primary" rounded="lg" prepend-icon="mdi-phone"
                class="white--text mb-2" @click="reserve">{{ $t('main.streamwall.full-stream.call_store') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-row>
  </v-container>
</template>

<script>
import { ref, inject, getCurrentInstance, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import CustomSocialsShare from '../custom/CustomSocialsShare.vue';

export default {
  components: {
    CustomSocialsShare
  },
  setup() {
    // const showSheet = ref(false);
    const config = {
      itemsToShow: 3
    }
    const openText = ref(false);
    const toggleText = () => {
      openText.value = !openText.value; // Toggle the open state
    }
    const { proxy } = getCurrentInstance();
    const openDownloadAppHint = inject('openDownloadAppHint')

    const selectedArea = inject('selectedArea')
    const selectedPost = ref(null);
    const selectedLanguage = localStorage.getItem('selectedLanguage');
    const router = useRouter();
    const route = useRoute();
    const activeSlide = ref(0);

    const fetchPost = async () => {
      try {
        const response = await proxy.$axios.get(`/stream/single/${route.params.headline}`);

        if (response.data.status == "OK") {
          selectedPost.value = response.data.data;
        }
      } catch (error) {
        console.error("Error: ", error);
      }
    }

    onMounted(() => {
      fetchPost();
    });


    return {
      selectedPost,
      activeSlide,
      selectedLanguage,
      openDownloadAppHint
      // showSheet:false,
    };
  },

  data() {
    return {
      page: 0,
      totalPages: null,
    }
  },

  watch: {

  },

  mounted() {

  },

  methods: {

  },
};
</script>

<style scoped>
.inner-main {
  margin: auto;
  max-width: 1170px;
}
</style>

<style></style>